// Central configuration for external URLs
export const PREVIEW_APP_URL = 'https://preview.garmischos.xyz/'
export const GITHUB_REPO_URL = 'https://github.com/AliAkberAakash/garmisch'

